import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EnvironmentProviders, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { apimApiVersion } from 'src/environments/environment';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class ApiVersionInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req.clone({
      params: apimApiVersion ? req.params.append(
        'api-version', apimApiVersion
      ) : req.params,
    }));
  }
}

export const ApiVersionInterceptorProvider: Provider | EnvironmentProviders = {
  provide: HTTP_INTERCEPTORS,
  useClass: ApiVersionInterceptor,
  multi: true,
};
